var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsuarioActivo24X24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.75C13.7949 3.75 15.25 5.20507 15.25 7C15.25 8.79493 13.7949 10.25 12 10.25C10.2051 10.25 8.75 8.79493 8.75 7C8.75 5.20507 10.2051 3.75 12 3.75ZM16.75 7C16.75 4.37665 14.6234 2.25 12 2.25C9.37665 2.25 7.25 4.37665 7.25 7C7.25 9.62335 9.37665 11.75 12 11.75C14.6234 11.75 16.75 9.62335 16.75 7Z",
    fill: "#88919E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3967 15.7238C13.9068 14.4774 10.0932 14.4774 6.60334 15.7238C6.0916 15.9065 5.75 16.3913 5.75 16.9347V18.2502C5.75 18.9812 6.39746 19.5427 7.12114 19.4394L8.07556 19.303C10.6786 18.9312 13.3214 18.9312 15.9244 19.303L16.8789 19.4394C17.6025 19.5427 18.25 18.9812 18.25 18.2502V16.9347C18.25 16.3913 17.9084 15.9065 17.3967 15.7238ZM6.09884 14.3112C9.91491 12.9483 14.0851 12.9483 17.9012 14.3112C19.0099 14.7071 19.75 15.7574 19.75 16.9347V18.2502C19.75 19.894 18.2941 21.1568 16.6667 20.9243L15.7123 20.7879C13.2499 20.4362 10.7501 20.4362 8.28769 20.7879L7.33327 20.9243C5.70594 21.1568 4.25 19.894 4.25 18.2502V16.9347C4.25 15.7574 4.99011 14.7071 6.09884 14.3112Z",
    fill: "#88919E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsuarioActivo24X24);
export default __webpack_public_path__ + "static/media/USUARIO_ACTIVO_24X24.59c3f53cbd84b1b8992dce59f093151e.svg";
export { ForwardRef as ReactComponent };